module.exports = __webpack_public_path__ + "img/pexels-jennifer-enujiugha-5157287_adobespark.4af38f60.png";